import React, { ErrorInfo } from 'react';

type IProps = {
  children: React.ReactNode;
};

class ErrorBoundary extends React.Component<IProps> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
